(function() {
    'use strict';
    angular
        .module('mVtasWebApp')
        .factory('Monitor', Monitor);

    Monitor.$inject = ['$resource', 'DateUtils'];

    function Monitor ($resource, DateUtils) {
        var resourceUrl =  'api/monitors/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.fecha = DateUtils.convertDateTimeFromServer(data.fecha);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
